"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PopoverBody", {
  enumerable: true,
  get: function get() {
    return _Body["default"];
  }
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _Arrow = require("./components/Arrow");

var _Body = _interopRequireDefault(require("./components/Body"));

var _Trigger = _interopRequireDefault(require("../Trigger"));

/**
 * Popover
 */
// eslint-disable-next-line complexity
var Popover = function Popover(_ref) {
  var children = _ref.children,
      open = _ref.open,
      anchor = _ref.anchor,
      placement = _ref.placement,
      onOutsideClick = _ref.onOutsideClick,
      constraintToWindow = _ref.constraintToWindow,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      positionVertical = _ref.positionVertical,
      positionHorizontal = _ref.positionHorizontal,
      arrowOffset = _ref.arrowOffset,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children", "open", "anchor", "placement", "onOutsideClick", "constraintToWindow", "offset", "positionVertical", "positionHorizontal", "arrowOffset"]);
  return /*#__PURE__*/React.createElement(_Trigger["default"], {
    open: open,
    face: anchor || /*#__PURE__*/React.createElement("div", {
      style: {
        width: 0,
        height: 0
      }
    }) //@ts-ignore
    ,
    positionVertical: positionVertical || ( //@ts-ignore
    ['top', 'bottom'].includes(placement) ? 'center' : placement) //@ts-ignore
    ,
    positionHorizontal: positionHorizontal || ( //@ts-ignore
    ['left', 'right'].includes(placement) ? 'middle' : placement),
    onOutsideClick: onOutsideClick,
    relativeOffset: _Arrow.arrowHeight + 3,
    relativeShift: typeof offset === 'string' ? offset : "".concat(offset / 2, "%"),
    constraints: constraintToWindow ? [{
      to: 'window',
      attachment: 'together'
    }] : undefined,
    classes: {
      element: 'tetherElement tether-element'
    }
  }, /*#__PURE__*/React.createElement(_Body["default"], (0, _extends2["default"])({}, rest, {
    arrowOffset: arrowOffset || offset,
    placement: placement
  }), children));
};

exports["default"] = Popover;
Popover.defaultProps = {
  placement: 'top',
  arrowOffset: 0
};
//# sourceMappingURL=index.js.map